export enum MESSAGE_SYSTEM_TYPE {
  MESSAGE_TYPE_WELCOME = 40001,
  MESSAGE_TYPE_END = 40002,
  MESSAGE_TYPE_TRANSFERING = 40004,
  MESSAGE_TYPE_TRANSFERED = 40003,
  CREATE_CONVERSATION_TYPE = 40005,
  SYSTEM_TIME_TYPE = 40007,
  // Display virtual agent job number message
  VIRTUAL_AGENT_ID = 40009,
}
export enum MESSAGE_QUESTION_TYPE {
  // Message guide card;
  QUESTION_CARD_TYPE = 41001,
  // Knowledge Base Association Question Card
  ROBOT_KNOWDGE_CARD = 41005,
  // Bot intercepts messages
  ROBOT_INTERCEPT_CARD = 41017,
}

export enum MESSAGE_ALL_TYPE {
  MESSAGE_TYPE_TEXT = 10001, //Text message
  MESSAGE_ONLY_USER_CAN_SEE = 40006,
  MESSAGE_TYPE_IMAGE = 10003, //Picture message
  MESSAGE_TYPE_VIDEO = 10004, //Video message
  MESSAGE_TYPE_FILE = 10005, //File message
  WEN_WEN_ROBOT_TYPE = 30001, //Ask a dedicated robot
  MESSAGE_TYPE_WELCOME = 40001, //Welcome language
  MESSAGE_TYPE_END = 40002, //Concluding remarks
  MESSAGE_TYPE_TRANSFERING = 40004, //Transfer start
  MESSAGE_TYPE_TRANSFERED = 40003, //Transfer complete
  CREATE_CONVERSATION_TYPE = 40005,
  SYSTEM_TIME_TYPE = 40007, //System time message
  // Display virtual agent job number message
  VIRTUAL_AGENT_ID = 40009,
  // Message guide card;
  QUESTION_CARD_TYPE = 41001,
  // Knowledge Base Association Question Card
  ROBOT_KNOWDGE_CARD = 41005,
  // Robot intercepts message card
  ROBOT_INTERCEPT_CARD = 41017,
  // [Continue to consult] message - > call the interface of the request problem card
  ROBOT_KEEP_GUIDE = 41003,
  // [Transfer manual] message - > call the interface of transfer
  ROBOT_TRANSFER_PEOPLE = 41004,
  // [Continue to consult] message - > user exits the queue
  KEEP_GUIDE_AFTER_CANCEL_DIALOG_QUEUE = 41011,
  // [Transfer to labor] message - > Transfer to labor keywords
  ROBOT_TRANSFER_PEOPLE_BY_KEYWORD = 41006,
  // Messages with like buttons and tap buttons
  ROBOT_THUMBS_TYPE = 41002,
  // Order card message
  ORDER_CARD_TYPE = 42001,
  // JARVIS message type
  JARVIS_TYPE = 40008,
  // After uploading through the client side, send the video
  CUSTOM_VIDEO_TYPE = 43001,
  SPECIAL_MESSAGE = 44001, // 抖音私信|bytehi等消息打通
}

export enum DOUYIN_TYPE {
  VOICE = 1001, // 语音
  IMAGE = 1002, // 图片
  FILE = 1003, // 文件
  VIDEO = 1004, // 视频
}

export enum DialogCreateResultType {
  /** Conversations are created normally, including bots, humans, offline sessions, etc */
  DIALOG_CREATED = 1,
  /** Session not created, go directly to offline form */
  OFFLINE_FORM = 2,
}

// Linkchat message targeting type
export enum MessagePosition {
  Left = 'left',
  Center = 'center',
  Right = 'right',
  Fixed = 'fixed',
  Auto = 'auto',
  ToMessageList = 'to-messagelist',
  SingleToMessageListCard = 'single-to-messagelist',
}
